import React from "react";
import { Copy } from "../../../atoms/Copy";

interface AcquisitionSectionProps {
  tracking?: Record<string, unknown> | null;
}

const ACQUISITION_LABELS: Record<string, string> = {
  utm_source: "UTM Source",
  utm_medium: "UTM Medium",
  utm_campaign: "UTM Campaign",
  utm_term: "UTM Term",
  utm_content: "UTM Content",
  gclid: "Google Ads click (gclid)",
  wbraid: "wbraid",
  gbraid: "gbraid",
  gad_source: "Google Ads source",
  ga_client_id: "Google Analytics client ID",
  fbp: "Meta fbp",
  fbc: "Meta fbc",
  bp_id: "Partner ID",
  client_ip_address: "IP address",
  client_user_agent: "User agent",
};

const PRIORITY_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "gad_source",
  "ga_client_id",
];

const prettifyKey = (key: string) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();

const toDisplayValue = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

const AcquisitionSection: React.FC<AcquisitionSectionProps> = ({
  tracking,
}) => {
  const entries = tracking
    ? Object.entries(tracking).filter(
        ([, v]) => v !== null && v !== undefined && v !== ""
      )
    : [];

  const sorted = entries.sort(([a], [b]) => {
    const ia = PRIORITY_KEYS.indexOf(a);
    const ib = PRIORITY_KEYS.indexOf(b);
    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });

  return (
    <div>
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
        Acquisition
      </p>
      {sorted.length === 0 ? (
        <p className="text-xs text-gray-400">No acquisition data</p>
      ) : (
        <dl className="grid grid-cols-[7.5rem_1fr] items-center gap-x-3 gap-y-1.5 text-xs">
          {sorted.map(([key, value]) => {
            const display = toDisplayValue(value);
            const isLong = display.length > 28;
            return (
              <React.Fragment key={key}>
                <dt className="text-gray-500">
                  {ACQUISITION_LABELS[key] ?? prettifyKey(key)}
                </dt>
                <dd className="min-w-0 text-gray-700">
                  {isLong ? (
                    <Copy target={display} truncate longVersion />
                  ) : (
                    <span className="break-words">{display}</span>
                  )}
                </dd>
              </React.Fragment>
            );
          })}
        </dl>
      )}
    </div>
  );
};

export default AcquisitionSection;
